<script>
import {setSeoOnWrapper} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

export default {
  name: "SingleProductWrapper",
  props: {
    productLink: {
      default: null,
    },
  },
  data() {
    return {
      product: {}
    }
  },
  computed: {
    shareLink() {
      return this.$route.name == 'ProductShare'
    }
  },
  methods: {},
  render() {
    return this.$slots.default({
      product: this.product.data !== undefined ? this.product.data.data : [],
    });
  },
  async mounted() {

    if (this.shareLink) {
      this.product = await this.$store.dispatch("Share/getShareContent", {slug: this.$route.params.name})
    } else {
      if (this.productLink == null) {
        this.product = await this.$store.dispatch("Product/getProductWithoutState", this.$route.params.name)
      } else {
        this.product = await this.$store.dispatch("Product/getProductWithoutState", this.productLink)
      }
    }


    this.$store.commit('Product/setProduct', this.product)

    this.$emit('product', this.product.data.data)
    setSeoOnWrapper(this.product.data.data, 'product')

  },
  watch: {
    $route: {
      async handler() {
        if (this.$route.name == 'Product') {
          this.product = await this.$store.dispatch("Product/getProductWithoutState", this.$route.params.name)
          await this.$emit('product', this.product.data.data)
        }
      },
    },
  },
}
</script>
